/**
 * Feuille de brouillon — la palette ne défile pas : quand ses bouts ne tiennent
 * pas dans la place qui lui est réservée, ils rapetissent d'un cran (44 px →
 * 38 → 33 → 29). La taille repart de la plus grande dès que le contenu ou la
 * largeur change. Le défilement ne reste qu'en dernier recours (plus petit cran
 * encore trop grand). Pur.
 */

export const PALETTE_SIZES = ['l', 'm', 's', 'xs'] as const;
export type PaletteSize = (typeof PALETTE_SIZES)[number];

/**
 * Cran suivant : le même si tout tient (marge d'1 px pour l'arrondi), le cran
 * plus petit si le contenu dépasse, le plus petit cran au plus.
 */
export function nextPaletteSize(
  current: PaletteSize,
  contentHeight: number,
  availableHeight: number,
): PaletteSize {
  if (availableHeight <= 0 || contentHeight <= availableHeight + 1) return current;
  const i = PALETTE_SIZES.indexOf(current);
  return PALETTE_SIZES[Math.min(i + 1, PALETTE_SIZES.length - 1)]!;
}
